import { EmailNotificationEvent, StatusLabel } from 'common/enums/emailNotifications.enums';
import { MAP_EMAIL_NOTIFICATION_EVENT_TO_STATUS_LABEL } from 'common/constants/emailNotifications.constants';

export const getCheckedEvents = (events?: EmailNotificationEvent[]) => {
  const checked: Record<StatusLabel, boolean> = {
    [StatusLabel.Pitched]: false,
    [StatusLabel.Processing]: false,
    [StatusLabel.Underwriting]: false,
    [StatusLabel.Approved]: false,
    [StatusLabel.Funded]: false,
    [StatusLabel.Rejected]: false,
  };

  if (events) {
    events.forEach((event) => {
      const label = MAP_EMAIL_NOTIFICATION_EVENT_TO_STATUS_LABEL[event];

      if (label) {
        checked[label as StatusLabel] = true;
      }
    });
  }

  return checked;
};
